import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

interface ApiResponse<T> {
  statusCode: number;
  data: T;
}

export async function getHelpContentByPage(page: string) {
  
  try {
    const response = await deiterateAPI.GET<ApiResponse<Record<string, any> | null>>(
      `/v1/help/page/${encodeURIComponent(page)}`,
      { backend: 'thalassa' }
    );
    
    if (!response.data) {
      // Help info not found for this page
      return null;
    }
    
    return response.data;
  } catch (error) {
    console.error('Error fetching help content:', error);
    return null;
  }
}
